import GeckoStore from '../gecko-store';
import GeckoFeatures from '../gecko-features';

const channelIsGlobal = (teamIds) => teamIds.length === 0;

const channelHasAgentsTeamId = (channelTeamIds, agentTeamIds) =>
  channelTeamIds.reduce(
    (match, channelTeam) => match || agentTeamIds.includes(channelTeam),
    false
  );

export const channelsForUsersTeams = (channels) => {
  if(!GeckoFeatures.can('team-channels')) {
    return channels
  }
  const agentTeams = GeckoStore.redux.get('appState.myTeamIds');

  return channels.filter(
    ({ assigned_team_ids }) =>
      channelIsGlobal(assigned_team_ids) ||
      channelHasAgentsTeamId(assigned_team_ids, agentTeams)
  );
};

export default {
  channelsForUsersTeams,
};
